import { getToken, getRefreshToken } from '../authentication/authProvider';

type EnsureContractOptions = {
  dealType: 'at_need' | 'pre_need';
  /**
   * 'explicit' when a human chose the region (the funeral form's required
   * radio), 'quote' when it was inherited from a quote and should only be
   * trusted if the quote actually carried one.
   */
  regionSource: 'explicit' | 'quote';
};

/**
 * Ask the backend to create this funeral's opening contract.
 *
 * The rule that picks the line items (region x deal type) lives in NestJS, not
 * here, so this path and aura's onboarding path cannot drift -- and so pricing,
 * which needs QuickBooks, happens where QuickBooks is reachable.
 *
 * Resolves rather than rejects on a declined or failed creation: the endpoint
 * always answers 200 with an outcome, and the caller treats a missing contract
 * as recoverable (staff use "Add contract"; the funerals list already alarms on
 * a funeral with none).
 */
export const ensureContractForFuneral = async (
  funeralId: number | string,
  options: EnsureContractOptions
): Promise<void> => {
  const response = await fetch(
    `${process.env.REACT_APP_PAPERMAN_API_URL}contract/ensure-for-funeral/${funeralId}`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${await getToken()}`,
        'Refresh-Token': await getRefreshToken(),
      },
      body: JSON.stringify(options),
    }
  );

  if (!response.ok) {
    console.error(
      'Auto-contract request failed for funeral',
      funeralId,
      response.status
    );
    return;
  }

  const result = await response.json();
  console.log('Auto-contract for funeral', funeralId, result?.outcome, result?.reason);
};
